














































import Vue from "vue";
import vClickOutside from "v-click-outside";

export default Vue.extend({
  name: "BaseInputEasy",
  directives: {
    clickOutside: vClickOutside.directive,
  },
  data() {
    return {
      oldValue: "",
      currentValue: "",
      isGrabbing: false,
      timeBeforeGrabbing: 0,
      collectedMovementX: 0,
      isShowModal: false,
      isActive: false,
      isInputActive: false,
      wasSliderPositionChange: false,
    };
  },
  props: {
    value: {
      type: [Number, String],
      required: true,
    },
    hint: {
      type: String,
    },
    label: {
      type: String,
    },
    type: {
      type: String,
    },
    isReactive: {
      type: Boolean,
      default: false,
    },
    isfloat: {
      type: Boolean,
      default: false,
    },
    min: {
      type: Number,
    },
    max: {
      type: Number,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    viewType: {
      type: String,
    },
  },
  methods: {
    onClickOutside(event) {
      if (!this.$refs.inputContainer.contains(event.target)) {
        this.$refs.input.blur();
        this.isInputActive = false;

        window.onmousedown = null;
      }
    },
    updateSelf(value: string) {
      if (this.isReactive) {
        let toReturn = this.getCorrectValue(value);
        //this.oldValue = toReturn;
        this.currentValue = toReturn;
        this.$emit("input", toReturn);
      } else {
        this.currentValue = value;
      }
      //this.value = toReturn;
      //this.$emit("input", toReturn);
    },
    focusInput() {
      this.$refs.input.focus();
    },
    blurInput() {
      this.$refs.input.blur();
    },
    getCorrectValue(value: string) {
      let toReturn: string | number = value;
      if (this.$props.type === "number") {
        toReturn = this.isfloat ? parseFloat(toReturn) : parseInt(toReturn);
        if (!toReturn || isNaN(<number>toReturn)) {
          toReturn = 0;
        }
        if (this.$props.min !== null && toReturn < this.$props.min) {
          toReturn = this.$props.min;
        }
        if (this.$props.max !== null && toReturn > this.$props.max) {
          toReturn = this.$props.max;
        }
        //Округление до двух знаков после запятой
        if (this.isfloat) {
          toReturn = Math.floor(<number>toReturn * 100) / 100;
        }
      }
      (<HTMLInputElement>this.$refs.input).value = toReturn.toString();
      return toReturn;
    },
    onBlur(event) {
      /* if (this.currentValue === "") {
        this.$emit("input", this.oldValue);
        this.currentValue = this.oldValue;
	  } else { */
      if (!this.isReactive) {
        this.currentValue = this.getCorrectValue(this.currentValue);
        this.$emit("input", this.currentValue);
      }
      this.$refs.input.blur();
      this.isInputActive = false;
    },

    startGrab(event) {
      if (!this.isInputActive) {
        event.stopPropagation();
        this.isGrabbing = true;
        window.onmousemove = this.moveCursorAt.bind(event);
        this.$emit("startDrag");

        this.startDragCursorPositionX = event.clientX;
        this.startDragValue = this.value;
        this.maxWidth = 300; //px
        this.step = (this.max - this.min) / this.maxWidth;

        this.collectedMovementX = this.value / this.step;
        this.isActive = true;
      } else {
        this.focusInput();
        this.isInputActive = true;
      }

      window.onmouseup = this.stopGrab.bind(event);
    },
    moveCursorAt(event) {
      if (
        (event.clientX - this.startDragCursorPositionX) * this.step <=
          this.max - this.startDragValue ||
        (this.startDragCursorPositionX - event.clientX) * this.step <=
          this.startDragValue - this.min
      ) {
        this.collectedMovementX += event.movementX;
        this.updateSelf(this.collectedMovementX * this.step);
        this.wasSliderPositionChange = true;
        this.$emit("timeChanged");
      }
    },
    stopGrab(event) {
      if (!this.wasSliderPositionChange) {
        this.isInputActive = true;
        this.focusInput();
        window.onmousedown = this.onClickOutside.bind(event);
      }
      this.wasSliderPositionChange = false;
      this.isGrabbing = false;
      this.collectedMovementX = 0;
      window.onmouseup = null;
      window.onmousemove = null;
      this.$emit("stopDrag");
      this.onMouseUp();
    },
    onMouseOut() {
      if (this.isActive) {
        this.isShowModal = true;
      }
    },
    onMouseUp() {
      if (this.isInputActive) {
        this.focusInput();
      }
      if (this.isActive) {
        this.isActive = false;
        this.isShowModal = false;
      }
    },
  },
});
